export enum EarnPreference {
  POINTS = "POINTS",
  STAMP = "STAMP",
}
